import React from 'react';
import FinalFormField from 'common/components/final-form/FinalFormField';
import Modal from 'common/components/modal/Modal';
import { Button, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap';
import { Form } from 'react-final-form';
import {
  IdentityDeniedAlert,
  IdentityNotUploadedAlert,
  MailingAddressNotCompleteAlert,
} from 'features/apply-for-registration/NotAllowedAlerts';
import ChsAddress from 'domain/types/ChsAddress';
import AddRegistrationRequest from 'domain/types/AddRegistrationRequest';

interface IAddRegistrationNumber {
  loading: boolean;
  isOpen: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  identity: {
    rejected: boolean;
    uploaded: boolean;
    loading: boolean;
  };
  profileAddress: ChsAddress;
  onSubmit: (req: AddRegistrationRequest) => void;
  submitError: string | null;
  isSidebar?: boolean;
}

const AddRegistrationNumberPresenter = (props: IAddRegistrationNumber) => {
  const restrictionAlerts: JSX.Element[] = [];
  function addRestrictionAlert(el: JSX.Element) {
    restrictionAlerts.push(el);
  }

  // Also pass through setOpen to close the modal no matter what
  if (!props.identity.uploaded) {
    addRestrictionAlert(
      <IdentityNotUploadedAlert
        adding
        closeModal={() => props.setOpen(false)}
      />
    );
  }
  if (props.identity.rejected) {
    addRestrictionAlert(
      <IdentityDeniedAlert adding closeModal={() => props.setOpen(false)} />
    );
  }
  if (!props.profileAddress) {
    addRestrictionAlert(
      <MailingAddressNotCompleteAlert
        adding
        closeModal={() => props.setOpen(false)}
      />
    );
  }

  let body = (
    <>
      <Form<AddRegistrationRequest>
        onSubmit={(values) => props.onSubmit(values)}
      >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <FinalFormField
              name='registrationId'
              label='Registration Number: *'
            />
            <FinalFormField
              name='email'
              label='Email associated with registration: *'
            />
            <div className='d-flex'>
              <Button type='submit' variant='primary' className='ml-auto'>
                Submit
              </Button>
            </div>
          </form>
        )}
      </Form>
      {props.submitError && (
        <div style={{ color: 'red' }}>{props.submitError}</div>
      )}
    </>
  );

  // If there are any restrictions, show them and disallow user from applying
  if (restrictionAlerts.length > 0) {
    body = <>{restrictionAlerts.map((a) => a)}</>;
  }

  if (props.loading || props.identity.loading) {
    body = <Spinner animation='border' />;
  }

  return (
    <>
      <Modal
        show={props.isOpen}
        toggle={() => {
          props.setOpen((prev) => !prev);
        }}
        title='Add Existing Registration Number / Renewal'
        body={body}
      />
      {!props.isSidebar ? (
        <OverlayTrigger
          overlay={
            <Tooltip id='city-debt'>
              Please only select this if you have an existing valid
              registration.
            </Tooltip>
          }
        >
          <Button variant={'primary'} onClick={() => props.setOpen(true)}>
            Add existing Registration Number / Renewal
          </Button>
        </OverlayTrigger>
      ) : null}
    </>
  );
};

export default AddRegistrationNumberPresenter;
